export enum enumExpiryDate {
  'Required' = 1,
  'Not Required',
  'Optional',
}

export namespace enumExpiryDate {
  export function values() {
    return Object.keys(enumExpiryDate).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
